export enum TipoNIRDOC {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  NI_INVALIDO = 'NI_INVALIDO'
}
